import axios from 'axios'
import _ from 'lodash'

// state
const state = {
	formData: {},
	dataForServer: {},
	isLoading: false,
	showTokenExpiredMessage: false,
	jobNotAvailable: false,
	jobNotFound: false,
	jobAvailable: false,
	captureSuccess: false,
	captureFailed: false,
	id: '',
	po_confirm_type_id: '',
  vendorAvailable: false,
  vendorBooked: false,


}

const getters = {
	/*
	 * Returns formData
	 */
	getFormData (state, {formData}) {
		return state.formData
	},

	/*
	 * Job has been filled
	 */
	checkJobNotAvailable(state){
		return state.jobNotAvailable;
	},

	/*
	 * Job not found
	 */
	checkJobNotFound(state){
		return state.jobNotFound;
	},

	/*
	 * Job found and available
	 */
	checkJobAvailable(state){
		return state.jobAvailable;
	},

	/*
	 * Show success message
	 */
	checkCaptureSuccess(state){
		return state.captureSuccess;
	},

	/*
	 * Show failed message
	 */
	checkCaptureFailed(state){
		return state.captureFailed;
	}
}


// mutations
const mutations = {
	/**
	 * Set object for push to API
	 */
	SET_DATA_FOR_SERVER(state, {key, value}){
		// append/update dataForServer
		state.dataForServer[key] = value;

		// need to set formData
		state.formData[key] = value;
	},

	/**
	 * Mutate variables
	 */
	SET_VARIABLE(state, {key, value}){
		eval('state.' + key + ' = value');
	},

	/**
	 * Reset vuex
	 */
	RESET_DATA_FOR_SERVER(state){
		state.dataForServer = {}
		state.formData = {}
	},

	/**
	 * Set formData
	 */
	SET_FORM_DATA (state, {formData}){
		state.formData = formData
	},

}

// actions
const actions = {
	/**
	 * Set variable
	 * @param {string}
	 * @param {boolean}
	 */
	setVariable({commit}, {key, value}){
		commit('SET_VARIABLE', {key: key, value: value});
	},

	/**
	 * Action to set dataForServer object
	 */
	 updateDataForServer({commit}, key, value){
		commit('SET_DATA_FOR_SERVER', key, value)
	},

	/**
	 * Check if job is still available
	 */
	async checkToken({commit, dispatch, rootState}, data){
		var id = data.id;
		var url = rootState.auth.l+'po-confirm/check-job';
		// save id to data store for later use.
		commit('SET_VARIABLE', {key: 'id', value: id})
		// pass it to api and check to make sure token exist & is not expired
		return axios.post(url, data)
			.then(response => {
				//console.log(response);
				//console.log(response.data.status);
				//console.log(response.data.data.original.data);
				if(response.data.data !== null){
				var data = response.data.data.original.data;
				commit('SET_FORM_DATA', {formData: data});
				}
				
				if(typeof(response.data.status) !== 'undefined'){
					switch(response.data.status){
						// Contain result
						case '200':
							commit('SET_VARIABLE', {key: 'jobAvailable', value: true});
							break;
						// No result
						case '400':
							commit('SET_VARIABLE', {key: 'jobNotFound', value: true});
							break;
						// Token has expired
						case '404':
							commit('SET_VARIABLE', {key: 'jobNotAvailable', value: true});
							break;
						// Availability already saved
						case '202':
							commit('SET_VARIABLE', {key: 'captureSuccess', value: true});
							break;
					}
				}
				return response;
				 
				// else {
				// 	commit('SET_VARIABLE', {key: 'jobAvailable', value: true});
				// 	var data = response.data.data.original.data;
				// 	commit('SET_FORM_DATA', {formData: data});
				// }
			})   
			.catch((error) => {
				console.log(error);
			});
	},

	/**
	 * Capture vendor's reminder confirmation
	 */
	async saveData({commit, dispatch, rootState, state}){
		var id = state.id;
		var po_confirm_type_id = state.po_confirm_type_id;
		var formData = state.formData;
		// var bool;
		// switch(val){
		// 	case 'Yes':
		// 		bool = true;
    //     		commit('SET_VARIABLE', {key: 'vendorAvailable', value: true});
		// 		break;
		// 	case 'No':
		// 		bool = false;
    //     		commit('SET_VARIABLE', {key: 'vendorBooked', value: true});
		// 		break;
		// }

		var data = {
			id: id,
			po_confirm_type_id: po_confirm_type_id
		}

		var url = rootState.auth.l+'po-confirm/capture/';

		// pass it to api and check to make sure token exist & is not expired
      return axios.post(url,data)
        .then(response => {
    		var data = response.data.data.original.data;
    		  commit('SET_FORM_DATA', {formData: data});

        	if(typeof(response.data.status) !== 'undefined'){
        		switch(response.data.status){
        			// Contain result
        			case '201':
						commit('SET_VARIABLE', {key: 'jobAvailable', value: false});
						commit('SET_VARIABLE', {key: 'captureSuccess', value: true});
        				break;
        		}
        	} else {
        		commit('SET_VARIABLE', {key: 'captureFailed', value: true});
        	}
        })   
        .catch((error) => {
			commit('SET_VARIABLE', {key: 'captureFailed', value: true});
        });
	},

	/**
	 * Clear vuex variables
	 */
	clear({commit, dispatch}){
		commit('RESET_DATA_FOR_SERVER');			// clear dataForServer
	}
}

export default {
    namespaced: true,
	state,
	getters,
	mutations,
	actions
}